/* Extracted from the inline <script> in snippets/pc-guarantee-modal.liquid so browsers can cache it; loaded with defer. Product values arrive via window.pcGuaranteeCfg, set inline by the snippet. */
(function () {
  'use strict';

  var RELAY_BASE   = 'https://relay.partcatalog.com/public';
  var STATE_KEY    = 'pc_guarantee_v1';
  var UID_KEY      = 'relay_uid';           /* same key relay.js uses */
  var MAX_DISMISS  = 2;
  var CFG          = window.pcGuaranteeCfg || {};
var SKU          = CFG.sku;
  var PRODUCT_TITLE = CFG.title;
  var PRODUCT_HANDLE = CFG.handle;

  var form = document.getElementById('pv2-product-form');
  var overlay = document.getElementById('pcg-overlay');
  if (!form || !overlay) return;

  /* ---------- tiny state helpers ---------- */
  function loadState() {
    try { return JSON.parse(localStorage.getItem(STATE_KEY)) || {}; } catch (e) { return {}; }
  }
  function saveState(patch) {
    var s = loadState();
    delete s.email;   /* drop an address an older build stored here */
    for (var k in patch) s[k] = patch[k];
    try { localStorage.setItem(STATE_KEY, JSON.stringify(s)); } catch (e) {}
    return s;
  }
  function getUid() {
    var uid = null;
    try { uid = localStorage.getItem(UID_KEY); } catch (e) {}
    if (!uid) {
      var m = document.cookie.match(/(?:^|;)\s*relay_uid=([^;]+)/);
      if (m) uid = decodeURIComponent(m[1]);
    }
    if (!uid || uid.length < 16) {
      uid = ('xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx').replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
    try { localStorage.setItem(UID_KEY, uid); } catch (e) {}
    document.cookie = 'relay_uid=' + encodeURIComponent(uid) +
      ';path=/;max-age=' + (60 * 60 * 24 * 365) + ';domain=.partcatalog.com;SameSite=Lax';
    return uid;
  }
  function savedVehicle() {
    try {
      var raw = localStorage.getItem('pc_ymm_v1');
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    return null;
  }
  function vehicleLabel(v) {
    if (!v) return '';
    return [v.year, v.make, v.model].filter(Boolean).join(' ');
  }
  function fitVerifiedOnPage() {
    var el = document.getElementById('fitment-result-true');
    return !!(el && el.style.display === 'block' && el.textContent.trim() !== '');
  }
  function fitFailedOnPage() {
    var el = document.getElementById('fitment-result-false');
    return !!(el && el.style.display === 'block' && el.textContent.trim() !== '');
  }

  /* ---------- fitment property + cart attributes ---------- */
  function writeFitmentProperty() {
    var input = document.getElementById('FitmentProperty');
    var src = document.getElementById('fitment-result-true');
    if (input && src && fitVerifiedOnPage()) {
      /* Normalize: the result banner reads "<strong>Fits your 2013 Toyota
         RAV4</strong><br />Position: Rear Right". Stored WITHOUT the
         "Fits your" prefix or strong tags - the cart badge adds its own
         prefix, which used to double it ("FITS YOUR FITS YOUR ..."). */
      var v = src.innerHTML.replace(/\s+/g, ' ').trim();
      v = v.replace(/<br\s*\/?>/gi, '<br />');
      v = v.replace(/<(?!br)[^>]*>/gi, '');
      v = v.replace(/^\s*Fits your\s+/i, '').trim();
      input.value = v;
    }
  }
  function setCartAttributes(activated, done) {
    var attrs = { relay_uid: getUid() };
    if (activated) {
      /* per-vehicle detail lives on each line item's Fitment property;
         the cart-level flag is just on/off */
      attrs.free_returns = 'activated';
    }
    var finished = false;
    var finish = function () { if (!finished) { finished = true; done(); } };
    /* never let a slow/failed attribute call block the purchase */
    setTimeout(finish, 1500);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      keepalive: true
    }).then(finish, finish);
  }

  /* ---------- modal machinery ---------- */
  var stepVehicle = document.getElementById('pcg-step-vehicle');
  var stepEmail   = document.getElementById('pcg-step-email');
  var slot        = document.getElementById('pcg-vehicle-slot');
  var chip        = document.getElementById('pcg-vehicle-chip');
  var emailInput  = document.getElementById('pcg-email');
  var errorEl     = document.getElementById('pcg-error');
  var activateBtn = document.getElementById('pcg-activate');
  var titleEl     = document.getElementById('pcg-title');
  var skipBtn     = document.getElementById('pcg-skip');
  var TITLE_DEFAULT = titleEl.textContent;

  var checkerHome = null;   /* original parent of .pv2-fitment-wrap */
  var checkerEl   = null;

  function moveCheckerIn() {
    checkerEl = document.querySelector('.pv2-fitment-wrap');
    if (!checkerEl || checkerEl.parentNode === slot) return;
    checkerHome = checkerEl.parentNode;
    slot.appendChild(checkerEl);
    /* if a previous verify hid the select container, bring it back */
    var container = document.getElementById('fitment-container');
    if (container && !fitVerifiedOnPage()) container.style.display = '';
  }
  function moveCheckerHome() {
    if (checkerEl && checkerHome && checkerEl.parentNode === slot) {
      checkerHome.appendChild(checkerEl);
    }
  }
  function showStep(which) {
    stepVehicle.hidden = which !== 'vehicle';
    stepEmail.hidden   = which !== 'email';
    skipBtn.hidden     = false;
    titleEl.textContent = TITLE_DEFAULT;
    if (which === 'vehicle') {
      moveCheckerIn();
    } else if (which === 'email') {
      moveCheckerHome();
      /* show the full verified-fit result (vehicle + Position/Note lines),
         exactly as the on-page checker rendered it */
      var res = document.getElementById('fitment-result-true');
      if (res && fitVerifiedOnPage()) {
        /* Copy the rendered nodes instead of re-parsing their markup */
        chip.textContent = '✓ ';
        Array.prototype.forEach.call(res.childNodes, function (n) { chip.appendChild(n.cloneNode(true)); });
      } else {
        chip.textContent = (vehicleLabel(savedVehicle()) || 'Vehicle confirmed') + ' ✓';
      }
      setTimeout(function () { emailInput.focus(); }, 60);
    }
  }
  function openModal(step) {
    window.__pcFitmentSurface = 'atc_modal';
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    showStep(step || (fitVerifiedOnPage() ? 'email' : 'vehicle'));
  }
  function closeModal() {
    moveCheckerHome();
    window.__pcFitmentSurface = null;
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  /* AJAX add-to-cart, then go to /cart. A classic full-page POST to
     /cart/add is invisible to Shopify's analytics pixel (it instruments
     fetch/XHR only), which zeroed the "Added to cart" funnel metric while
     checkouts kept counting (13 adds vs 57 checkouts, Sep 2026). fetch to
     /cart/add.js is what the pixel counts. Falls back to the native submit
     on any error - tracking must never block a purchase. */
  function ajaxAddToCart() {
    var fell = false;
    function fallback() { if (!fell) { fell = true; try { form.submit(); } catch (e) {} } }
    try {
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (r) {
        if (!r.ok) { fallback(); return; }
        window.location.href = '/cart';
      }).catch(fallback);
    } catch (err) { fallback(); }
  }

  /* continue the intercepted purchase: property + attributes, then AJAX add */
  function continueToCart(activated) {
    writeFitmentProperty();
    setCartAttributes(activated, function () {
      closeModal();
      ajaxAddToCart();
    });
  }

  /* Extra tags for every add_to_cart this file logs: where the tap came from
     (buy_box | sticky_bar, set by the sticky bar script in main-product-v2).
     Experiment props (experiment, variant) come from the running test's
     block in main-product-v2, which wraps Relay.track for add_to_cart. */
  function expProps(extra) {
    var p = extra || {};
    try {
      var src = form.getAttribute('data-atc-source');
      if (src) p.atc_source = src;
    } catch (err) {}
    return p;
  }

  /* ---------- intercept Add to Cart ---------- */
  form.addEventListener('submit', function (e) {
    var s = loadState();
    /* Pass straight through when there is no offer to make:
       - shopper dismissed the offer twice
       - the part is verified NOT to fit (no guarantee to offer)
       - email + fitment both already known (repeat purchases) */
    var passthrough = (s.dismissals || 0) >= MAX_DISMISS || fitFailedOnPage()
                   || (s.captured && fitVerifiedOnPage());
    if (passthrough) {
      writeFitmentProperty();
      /* fire-and-forget attributes; do not delay a normal purchase */
      try { setCartAttributes(!!s.captured, function () {}); } catch (err) {}
      if (window.Relay && window.Relay.track) {
        /* flat props - Relay.track's second argument IS the props object */
        window.Relay.track('add_to_cart', expProps({ sku: SKU }));
      }
      /* AJAX instead of native submit so Shopify's pixel sees the add
         (see ajaxAddToCart above); it falls back to form.submit() on error */
      e.preventDefault();
      e.stopImmediatePropagation();
      ajaxAddToCart();
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    openModal(null);
  }, true);

  /* fitment checker verified inside (or outside) the modal */
  document.addEventListener('fitment:verified', handleVerified, true);
  var checkerRoot = document.getElementById('fitment-checker');
  if (checkerRoot) checkerRoot.addEventListener('fitment:verified', handleVerified);
  function handleVerified(e) {
    if (!overlay.classList.contains('is-visible')) return;
    if (e.detail && e.detail.fits) {
      /* email already on file: fitment was the only missing piece - the
         guarantee is active for this item too, no need to ask again */
      if (loadState().captured) {
        continueToCart(true);
        return;
      }
      showStep('email');
    } else {
      /* does not fit: close and let the site's no-fit popup take over */
      closeModal();
    }
  }

  /* change vehicle from the email step */
  document.getElementById('pcg-change').addEventListener('click', function () {
    var container = document.getElementById('fitment-container');
    var resTrue = document.getElementById('fitment-result-true');
    if (resTrue) resTrue.style.display = 'none';
    if (container) container.style.display = '';
    showStep('vehicle');
  });

  /* dismiss paths: still add to cart, still go to /cart */
  function dismiss() {
    var s = loadState();
    saveState({ dismissals: (s.dismissals || 0) + 1 });
    /* log the declined offer so the dashboard can compute capture rate
       (the accepted path is logged server-side by identify.php) */
    if (window.Relay && window.Relay.track) {
      window.Relay.track('add_to_cart',
        expProps({ sku: SKU, form_id: 'atc_guarantee', captured: false }));
    }
    continueToCart(false);
  }
  document.getElementById('pcg-skip').addEventListener('click', dismiss);
  document.getElementById('pcg-close').addEventListener('click', dismiss);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) dismiss(); });

  /* ---------- a11y: Escape, Tab trap, focus restore (ported from
     sections/main-cart-items.liquid pc-fitment-modal pattern) ---------- */
  document.addEventListener('keydown', function (e) {
    /* Bail if a nested widget already consumed this Escape (e.g. the reparented
       .pv2-fitment-wrap's .pc-fdd searchable dropdowns call preventDefault() on
       Escape to close just the listbox) - otherwise it would bubble up here and
       abandon/submit the whole guarantee flow instead. */
    if (e.defaultPrevented) return;
    if (e.key === 'Escape' && overlay.classList.contains('is-visible')) dismiss();
  });

  overlay.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusables = Array.prototype.filter.call(
      overlay.querySelectorAll('button, select, input, a[href], [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* Invariant this relies on: openModal()'s own focus() calls (emailInput /
     the reparented checker) are all deferred via setTimeout, so this observer's
     callback - which runs as a microtask right after the synchronous
     classList.add('is-visible') - always fires and captures document.activeElement
     BEFORE any of those deferred focus() calls run. If a future edit moves one of
     those focus() calls to run synchronously, this capture will grab the wrong
     element and focus-restore will break silently. */
  var pcgLastFocus = null;
  new MutationObserver(function () {
    if (overlay.classList.contains('is-visible')) {
      if (!pcgLastFocus) pcgLastFocus = document.activeElement;
    } else if (pcgLastFocus) {
      if (pcgLastFocus.focus) pcgLastFocus.focus();
      pcgLastFocus = null;
    }
  }).observe(overlay, { attributes: true, attributeFilter: ['class'] });

  /* ---------- activate ---------- */
  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  /* Shared capture POST: 4s bail-out, and a network failure NEVER loses the
     sale - treat as captured-ish and continue. finish(true) = proceed. */
  function postCapture(email, formId, consentTextId, captureVariant, finish) {
    var v = savedVehicle() || {};
    var payload = {
      uid: getUid(),
      email: email,
      form_id: formId,
      consent: true,
      consent_text: document.getElementById(consentTextId).textContent.trim(),
      source_url: window.location.href,
      vehicle: { year: v.year, make: v.make, model: v.model },
      sku: SKU,
      product_handle: PRODUCT_HANDLE,
      event_name: 'add_to_cart',
      props: expProps({ capture_variant: captureVariant, product: PRODUCT_TITLE })
    };

    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (ctrl) ctrl.abort();
      finish(true);
    }, 4000);

    fetch(RELAY_BASE + '/identify.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      clearTimeout(timer);
      if (res.ok) { finish(true); return; }
      return res.json().then(function () { finish(false); }, function () { finish(false); });
    }, function () {
      clearTimeout(timer);
      finish(true);   /* network error: continue the sale */
    });
  }

  document.getElementById('pcg-activate').addEventListener('click', function () {
    var email = (emailInput.value || '').trim();
    if (!validEmail(email)) {
      emailInput.classList.add('pcg-invalid');
      errorEl.hidden = false;
      emailInput.focus();
      return;
    }
    emailInput.classList.remove('pcg-invalid');
    errorEl.hidden = true;
    activateBtn.disabled = true;
    activateBtn.textContent = 'Activating…';

    postCapture(email, 'atc_guarantee', 'pcg-consent-text', 'B', function (ok) {
      if (ok) {
        saveState({ captured: true });   /* the address never goes into localStorage */
        continueToCart(true);
      } else {
        activateBtn.disabled = false;
        activateBtn.textContent = 'Activate & Add to Cart';
        emailInput.classList.add('pcg-invalid');
        errorEl.textContent = 'That email address doesn’t look right — please check it and try again.';
        errorEl.hidden = false;
      }
    });
  });

  /* enter key in the email field activates */
  emailInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); activateBtn.click(); }
  });
})();
